export default __webpack_public_path__ + "images/f6f83120e68abe4a1ced93a93a76e49e.svg";